var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FC7100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 41.5C26.86 41.5 23.5 44.845 23.5 49C23.5 53.155 26.86 56.5 31 56.5C35.14 56.5 38.5 53.14 38.5 49C38.5 44.86 35.155 41.5 31 41.5ZM27.94 45.94H31C31.57 45.94 32.02 46.405 32.02 46.96C32.02 47.515 31.57 47.98 31 47.98H27.94C27.37 47.98 26.92 47.515 26.92 46.96C26.92 46.405 27.37 45.94 27.94 45.94ZM34.06 52.06H27.94C27.37 52.06 26.92 51.595 26.92 51.04C26.92 50.485 27.385 50.02 27.94 50.02H34.075C34.645 50.02 35.095 50.485 35.095 51.04C35.095 51.595 34.63 52.06 34.06 52.06Z",
    fill: "#FC7100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 26.5H32.5C28 26.5 25 28.75 25 34V38.71C25 39.805 26.125 40.495 27.13 40.06C28.78 39.34 30.655 39.07 32.62 39.385C36.55 40.03 39.76 43.135 40.555 47.035C40.78 48.175 40.81 49.285 40.66 50.35C40.54 51.235 41.26 52.015 42.145 52.015H47.5C52 52.015 55 49.765 55 44.515V34C55 28.75 52 26.5 47.5 26.5ZM48.205 34.885L43.51 38.635C42.52 39.43 41.26 39.82 40 39.82C38.74 39.82 37.465 39.43 36.49 38.635L31.795 34.885C31.315 34.495 31.24 33.775 31.615 33.295C32.005 32.815 32.71 32.725 33.19 33.115L37.885 36.865C39.025 37.78 40.96 37.78 42.1 36.865L46.795 33.115C47.275 32.725 47.995 32.8 48.37 33.295C48.76 33.775 48.685 34.495 48.205 34.885Z",
    fill: "#FC7100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3a4fc457feb4e61f7043b080b857116c.svg";
export { ForwardRef as ReactComponent };